<template>
  <q-page padding>
    <header-my-channels :viewAdd="viewAdd" />
    <list-my-channels
      :viewAdd="viewAdd"
      :existing-payment-info="existingPaymentInfo"
      @viewAddTrue="viewAdd = true"
    />
    <form-my-channels />
  </q-page>
</template>

<script>
import ListMyChannels from '../../components/channel/ListMyChannels.vue';
import HeaderMyChannels from '../../components/channel/HeaderMyChannels.vue';
import FormMyChannels from '../../components/channel/FormMyChannels.vue';
import affiliateService from '../../services/AffiliateService';
export default {
  components: { HeaderMyChannels, ListMyChannels, FormMyChannels },
  mixins: [affiliateService],
  name: 'PageMyChannels',

  data() {
    return {
      viewAdd: false,
      existingPaymentInfo: null
    };
  },

  created() {
    this.getAffiliatePayInfo();
  },

  methods: {
    hasChannelRegistrationRequirements(paymentInfos) {
      if (!Array.isArray(paymentInfos) || paymentInfos.length === 0) return false;

      return paymentInfos.some(
        (item) =>
          !!item.document_type &&
          !!item.document_number &&
          this.isValidBrazilianMobilePhone(item.phone_number)
      );
    },

    async getAffiliatePayInfo() {
      this.onLoading(true);
      try {
        const { data, status } = await this.getAffiliateDataPayment();
        if (status === 200) {
          this.existingPaymentInfo = Array.isArray(data) && data.length ? data[0] : null;
          this.viewAdd = this.hasChannelRegistrationRequirements(data);
        }
      } finally {
        this.onLoading(false);
      }
    }
  }
};
</script>
